import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import {
  GatewaysDetailsItemFromServer,
  GatewaysDetailsRequest,
  GatewaysDetailsResponse,
} from './types'

export const gatewaysDetailsMounted = createEvent<GatewaysDetailsRequest>()

export const getGatewaysDetails = fx<void, GatewaysDetailsResponse>({
  method: 'GET',
  url: `/finance/gateway`,
})

export const $gatewaysDetails = restore<GatewaysDetailsItemFromServer[]>(
  getGatewaysDetails.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfGatewaysDetail = restore(
  getGatewaysDetails.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: gatewaysDetailsMounted,
  fn: ({ limit, page, paymentSystemId }) => {
    let query = {
      limit,
      page,
    }

    // @ts-ignore
    query['where'] = `${JSON.stringify({
      ['paymentSystemId']: String(paymentSystemId),
    })}`

    // @ts-ignore
    query['order'] = '-gatewayId'
    return {
      url: `/finance/gateway`,
      query,
    }
  },
  target: getGatewaysDetails,
})
